import { CashbackToggleType } from '../../../../../components-library/checkout/CashbackToggle';

export default {
  [CashbackToggleType.Default]: {
    balance: '{{value}}p ({{moneyValue}}) verfügbar',
    optional: 'Nutze oder sammle weiter Punkte',
    states: {
      on: 'Ja',
      off: 'Nein',
    },
  },
  [CashbackToggleType.Points]: {
    title_one: 'Du hast {{count}} Punkt',
    title_other: 'Du hast {{count}} Punkte',
    use_points: 'Nutze <highlight>{{value}} Punkte ({{moneyValue}})</highlight>',
    buttons: {
      enabled: 'Rückgängig',
      use: 'Nutzen',
    },
  },
  feedback: {
    min_spending_limit_not_reached: 'Löse deine Punkte ein, sobald du min. {{value}} Punkte hast',
    max_spending_limit: 'Maximal {{value}} Punkte pro Bestellung',
  },
  cashback: {
    enabled: 'Loyalty Punkte erfolgreich angewendet',
    cashback_removed: 'Loyalty Punkte entfernt',
  },
};
